import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Container, Row, Col, Table, Button, Form } from 'react-bootstrap';
import { BiSearchAlt, BiSolidFileExport } from 'react-icons/bi';
import '../../shared/Shared.css';
import LoadingSpinner from '../../shared/LoadingSpinner';
import { ToastContainer } from 'react-toastify';
import { VedikaService } from '../../services/VedikaService';
import { utils, writeFile } from 'xlsx';
import 'datatables.net-buttons';
import * as moment from 'moment';
import $ from 'jquery';
import JSZip from 'jszip';
window.JSZip = JSZip;

const RekapClaim = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [listDataKlaim, setlistDataKlaim] = useState([]);
    const [periodeAwal, setperiodeAwal] = useState(new Date());
    const [periodeAkhir, setperiodeAkhir] = useState(new Date());

    const loadInit = () => {
        setIsLoading(true);
        let tglAwal = moment(periodeAwal).format('YYYY-MM-DD');
        let tglAkhir = moment(periodeAkhir).format('YYYY-MM-DD');
        const promise1 = VedikaService.getRekapKlaimReport(`tglAwal=${tglAwal} 00:00:00&tglAkhir=${tglAkhir} 23:59:59`);
        const allPromise = Promise.all([promise1]);
        allPromise.then(val => {
            if (val[0].data.data.length > 0) {
                setlistDataKlaim(val[0].data.data);
            }
        })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const handlePeriodeAwal = () => {
        setperiodeAwal($('#tglAwal').val());
    }
    const handlePeriodeAkhir = () => {
        setperiodeAkhir($('#tglAkhir').val());
    }

    const loadDtList = () => {
        $('#dt-rekap').DataTable({
            data: listDataKlaim,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            // scrollY: '50vh',
            destroy: true,
            autoWidth: false,
            dom: 'Bfrtip',
            buttons: [
                'excel'
            ],
            columns: [
                {
                    targets: [0],
                    data: 'tglregis',
                    width: '10%'
                },
                {
                    targets: [1],
                    data: 'total',
                    width: '5%'
                },
                {
                    targets: [2],
                    data: 'jml_sep_non_kelas',
                    width: '5%'
                },
                {
                    targets: [3],
                    data: 'jml_klaim_non_kelas',
                    width: '5%'
                },
                {
                    targets: [4],
                    data: 'jml_sep_kelas_1',
                    width: '5%'
                },
                {
                    targets: [5],
                    data: 'jml_klaim_kelas_1',
                    width: '5%'
                },
                {
                    targets: [6],
                    data: 'jml_sep_kelas_2',
                    width: '5%'
                },
                {
                    targets: [7],
                    data: 'jml_klaim_kelas_2',
                    width: '5%'
                },
                {
                    targets: [8],
                    data: 'jml_sep_kelas_3',
                    width: '5%'
                },
                {
                    targets: [9],
                    data: 'jml_klaim_kelas_3',
                    width: '5%'
                },
                {
                    targets: [10],
                    data: 'jml_sep_kelas_vip_a',
                    width: '5%'
                },
                {
                    targets: [11],
                    data: 'jml_klaim_kelas_vip_a',
                    width: '5%'
                },
                {
                    targets: [12],
                    data: 'jml_sep_kelas_vip_b',
                    width: '5%'
                },
                {
                    targets: [13],
                    data: 'jml_klaim_kelas_vip_b',
                    width: '5%'
                },
            ],
            dom: 'fr<"#export-toolbar.toolbar">tip',
        }
        )
    }
    const renderEl = () => {
        const elToolbar = createRoot(document.getElementById('export-toolbar'));
        elToolbar.render(<Row><Col md={2}><Form.Group as={Col} id="export">
            <div className="d-grid gap-2">
                <Button className='mtc-2' variant="secondary" size="sm" onClick={exportData}><BiSolidFileExport />Export Excel</Button>
            </div>
        </Form.Group></Col></Row>);
    }

    const headerExportData1 = [
        "Tanggal",
        "Total",
        "Non Kelas",
        "",
        "Kelas I",
        "",
        "kelas II",
        "",
        "Kelas III",
        "",
        "VIP A",
        "",
        "VIP B",
        "",
    ];
    const headerExportData2 = [
        "",
        "",
        "SEP",
        "Klaim",
        "SEP",
        "Klaim",
        "SEP",
        "Klaim",
        "SEP",
        "Klaim",
        "SEP",
        "Klaim",
        "SEP",
        "Klaim",
    ];

    const exportData = () => {
        var data = $('#dt-rekap').DataTable()
            .columns()
            .data()
            .toArray();
        let arrExport = [];
        let lengthData = data[0].length;
        let lengthRows = data.length;
        for (let d = 0; d < lengthData; d++) {
            let arr = [];
            for (let i = 0; i < lengthRows; i++) {
                arr.push(data[i][d]);
            }
            arrExport.push(arr)
        }
        let wb = utils.book_new(),
            ws = utils.json_to_sheet(arrExport, {skipHeader: true});
        utils.sheet_add_aoa(ws, [headerExportData1, headerExportData2]);
        // const merge = [
        //     {
        //         s: { r: 0, c: 0 },
        //         r: { r: 1, c: 0 }
        //     },
        //     {
        //         s: { r: 0, c: 1 },
        //         r: { r: 1, c: 1 }
        //     },
        //     {
        //         s: { r: 0, c: 2 },
        //         r: { r: 1, c: 3 }
        //     },
        //     {
        //         s: { r: 0, c: 4 },
        //         r: { r: 1, c: 5 }
        //     },
        //     {
        //         s: { r: 0, c: 6 },
        //         r: { r: 1, c: 7 }
        //     },
        //     {
        //         s: { r: 0, c: 8 },
        //         r: { r: 1, c: 9 }
        //     },
        //     {
        //         s: { r: 0, c: 10 },
        //         r: { r: 1, c: 11 }
        //     },
        //     {
        //         s: { r: 0, c: 12 },
        //         r: { r: 1, c: 13 }
        //     },
        // ]
        // ws['!merges'] = merge;
        utils.book_append_sheet(wb, ws, "Rekap");

        writeFile(wb, "Rekap Claim.xlsx")
    }

    useEffect(() => {
        loadInit()
    }, [])

    useEffect(() => {
        $('#dt-rekap').DataTable().clear().draw();
        loadDtList();
        renderEl();
    }, [listDataKlaim])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <ToastContainer />
            <Container fluid className='pb-5'>
                <Row>
                    <Col className='text-center bg-success text-white'>
                        <h5>Rekap Klaim</h5>
                    </Col>
                </Row>
                <Row className='mb-1 pt-1'>
                    <Form.Group as={Col} controlId="tglAwal">
                        <Form.Label>Periode Awal</Form.Label>
                        <Form.Control size="sm" type="date" onChange={handlePeriodeAwal} ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col} controlId="tglAkhir">
                        <Form.Label>Periode Akhir</Form.Label>
                        <Form.Control size="sm" type="date" onChange={handlePeriodeAkhir}></Form.Control>
                    </Form.Group>
                    {/* <Form.Group as={Col} controlId="ruangan2">
                    <Form.Label>Dpjp</Form.Label>
                    <Select
                        cacheOptions
                        styles={customStyles}
                        value={selectedDpjp}
                        getOptionLabel={e => e.namalengkap}
                        getOptionValue={e => e.id}
                        options={listDpjp}
                        onChange={handleChangeDpjp}
                    />
                </Form.Group> */}
                    <Form.Group as={Col} id="search">
                        <div className="d-grid gap-2">
                            <Button className='mtc-2' variant="success" size="sm" onClick={loadInit}><BiSearchAlt />Cari</Button>
                        </div>
                    </Form.Group>
                    {/* <Form.Group as={Col} id="export">
                        <div className="d-grid gap-2">
                            <Button className='mtc-2' variant="secondary" size="sm" onClick={exportData}><BiSolidFileExport />Export Excel</Button>
                        </div>
                    </Form.Group> */}
                </Row>
                <Row>
                    <Col>
                        <Table responsive="sm" size="sm" id='dt-rekap' bordered hover style={{ fontSize: 'smaller' }}>
                            <thead>
                                <tr>
                                    <th rowSpan={2}>Tanggal</th>
                                    <th rowSpan={2}>Total</th>
                                    <th colSpan={2}>Non kelas</th>
                                    <th colSpan={2}>Kelas I</th>
                                    <th colSpan={2}>Kelas II</th>
                                    <th colSpan={2}>Kelas III</th>
                                    <th colSpan={2}>VIP A</th>
                                    <th colSpan={2}>VIP B</th>
                                </tr>
                                <tr>
                                    <th>SEP</th>
                                    <th>Klaim</th>
                                    <th>SEP</th>
                                    <th>Klaim</th>
                                    <th>SEP</th>
                                    <th>Klaim</th>
                                    <th>SEP</th>
                                    <th>Klaim</th>
                                    <th>SEP</th>
                                    <th>Klaim</th>
                                    <th>SEP</th>
                                    <th>Klaim</th>
                                </tr>
                            </thead>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
}

export default RekapClaim;